import { refreshAccessToken } from "pianofunclub-crm/relay/refreshAccessToken";
import { getValueFromLocalStorage } from "pianofunclub-crm/utils/localStorage";

export const getAccessToken = async (variables: {
  clientSideLogout: () => void;
  fetchUrl: string;
}) => {
  const { clientSideLogout, fetchUrl } = variables;

  const accessToken = getValueFromLocalStorage("token");

  if (!accessToken) {
    return Promise.resolve("");
  }

  const accessTokenExpiresAt = getValueFromLocalStorage("token_expires_at")
    ? parseInt(getValueFromLocalStorage("token_expires_at") ?? "0")
    : 0;
  const refreshToken = getValueFromLocalStorage("refresh_token");
  const refreshTokenExpiresAt = getValueFromLocalStorage("refresh_token_expires_at")
    ? parseInt(getValueFromLocalStorage("refresh_token_expires_at") ?? "0")
    : 0;

  const currentUnixTime = Math.floor(Date.now() / 1000);

  const accessTokenExpirationBuffer = 60 * 5; // 5 minutes
  if (
    !accessTokenExpiresAt ||
    // refresh if expires within the next 5 minutes
    accessTokenExpiresAt - currentUnixTime < accessTokenExpirationBuffer
  ) {
    if (refreshToken) {
      return await refreshAccessToken({
        clientSideLogout,
        fetchUrl,
        refreshToken,
        refreshTokenExpiresAt,
      });
    }
  }

  return Promise.resolve(accessToken);
};
